<template>
  <div class="recall-page">
    <div v-wechat-title="'《提灯与地下城》海灵主宰·龙拳破天'"></div>
    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' :gameName="gameName" :game_id="39" :downloadUrl="downloadUrl" :loginTypes="loginTypes"
      channelTips="角色UID可在游戏中—设置—UID查看" :autoOpenOS='false' @loginSuccess="loginSuccess" noAuthLogin></Login>
    <Os v-if='isShowOs' v-on:logoutCallback='osCancell' @getSelectInfo='getSelectInfo' :gameName="gameName"
      :autoOpenOS="false"></Os>
    <!-- 头部 -->
    <Header v-if='true' :config='headerConfig' :isShowInfo='true' @reInit="reInit" :isOnline='0'
      :newUserInfo="newUserInfo" />

    <!-- 首页 -->
    <div :class="`active-page ${(isBook && signCount !== 3) ? 'sign-bg' : ''}`">
      <div class="section-container">
        <div class="section section1">
          <div class="banner">
            <div class="banner-title" />
          </div>
          <div class="character" />
          <div :class="'skill ' + skillClass">
            <div class="skill-intro">
              <div class="skill-intro-item" v-for="(item, index) in skill_intro_items">
                <img :class="item.status == 2 ? 'skill-intro-item-img' : 'skill-intro-item-img active'"
                  :src="item.image" />
              </div>
            </div>
            <div class="skill-intro-content">
              <img :src="skillGif" />
            </div>
          </div>
          <div class="experience">
            <div class="experience-intro">
              <img class="experience-intro-img " :src="experienceGif" />
            </div>
          </div>
          <div class="competition">
          </div>
        </div>
      </div>
    </div>

    <!-- 周年服福利详情弹窗 -->
    <div class="welfare-detail-pop popup_wrap" v-show="welfareDetailShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="welfare-box popup_wrap-box" v-show="welfareDetailShow">
          <div class="detail-content-wrapper">
            <div class="detail-content"></div>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-show="welfareDetailShow" @click="closePopup('welfareDetailShow')"></div>
    </div>

    <!-- 周年服预约成功弹窗 -->
    <div class="appoint-success-pop popup_wrap" v-show="appointSuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="success-box popup_wrap-box" v-show="appointSuccessShow">
          <div class="confirm-btn" @click="changeToSign()"></div>
        </div>
      </transition>
    </div>

    <!-- 每日签到成功弹窗 -->
    <div class="sign-success-pop popup_wrap" v-show="signSuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="success-box popup_wrap-box" v-show="signSuccessShow">
          <div class="confirm-btn" @click="closePopup('signSuccessShow')"></div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '../Header/index.vue';
import Footer from '@/components/Footer'
import { headerConfig } from '../headerConfig';
import { onGetInitDataAPI, appointAPI, signAPI } from '../api'
import { getRandomString, buriedLogger } from '@/utils/utils'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'recall',
  components: {
    Header,
    Footer,
    Login,
    Os,
    swiper,
    swiperSlide,
  },
  props: {
    logger: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.logger.sum('拳新版本_角色页');
        }
      }
    }
  },
  data() {
    return {
      newUserInfo: {},
      headerConfig,
      gameName: 'tideng',
      account: null,
      user_id: null,
      role_name: '',
      server_name: '',
      downloadUrl: 'https://tideng.qingcigame.com/',
      loginTypes: ["sms", "password"],
      mySwiper: null,
      tabs: [1, 2, 3],
      activeIndex: 0,
      showTopBox: false,
      showTitleBox: false,
      isBook: false,
      isCanSign: false,
      isDaySign: false,
      signCount: 0,

      // 弹窗
      welfareDetailShow: false, // 福利详情弹窗
      appointSuccessShow: false, // 预约成功弹窗
      signSuccessShow: false, // 签到成功弹窗
      skill_intro_items: [
        {
          image: 'https://download4.qcplay.com/h5-images/active/tideng/recall/chongquan.png',
          status: 1,
          image_active: 'https://download4.qcplay.com/h5-images/active/tideng/recall/chongquan_active.png',
          class: 'skill-c',
          gif: 'https://download4.qcplay.com/h5-images/active/tideng/recall/chongquan.gif'
        },
        {
          image: 'https://download4.qcplay.com/h5-images/active/tideng/recall/youlong.png',
          status: 2,
          image_active: 'https://download4.qcplay.com/h5-images/active/tideng/recall/youlong_active.png',
          class: 'skill-y',
          gif: 'https://download4.qcplay.com/h5-images/active/tideng/recall/youlong.gif'
        },
        {
          image: 'https://download4.qcplay.com/h5-images/active/tideng/recall/longhu.png',
          status: 1,
          image_active: 'https://download4.qcplay.com/h5-images/active/tideng/recall/longhu_active.png',
          class: 'skill-l',
          gif: 'https://download4.qcplay.com/h5-images/active/tideng/recall/longhu.gif'
        }
      ],

      skillClass: 'skill-y',
      skillGif: 'https://download4.qcplay.com/h5-images/active/tideng/recall/youlong.gif',
      experienceGif: 'https://download4.qcplay.com/h5-images/active/tideng/recall/daguai.gif',
      timer: null
    }
  },
  created() {// 获取url上的参数
    const urlParams = new URLSearchParams(window.location.search);
    this.code = urlParams.get('code');
    this.auth_code = urlParams.get('auth_code');
    this.friend_id = urlParams.get('friend_id');
    const queryUA = urlParams.get('ua');
    const module = urlParams.get('module');
    const type = urlParams.get('type');

    urlParams.delete('code');
    urlParams.delete('auth_code');
    urlParams.delete('friend_id');
    urlParams.delete('module');
    urlParams.delete('ua');
    urlParams.delete('type');
    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    window.history.replaceState(null, '', newUrl);
    if (type === 'by3') {
      this.headerConfig.operation_btn.download.link = 'https://download4.qcplay.com/apk-v2/qc-kol-1168625.apk'
    } else {
      this.headerConfig.operation_btn.download.link = 'https://download4.qcplay.com/apk-v2/qc-kol-1168626.apk'
    }
    if (/iP(hone|od|ad)/.test(navigator.userAgent)) {
      this.headerConfig.operation_btn.download.link = 'https://apps.apple.com/cn/app/%E6%8F%90%E7%81%AF%E4%B8%8E%E5%9C%B0%E4%B8%8B%E5%9F%8E-1-5%E7%89%88%E6%9C%AC%E5%85%89%E6%9A%97%E5%AF%B9%E5%86%B3/id1507356201?l=en'
    }
    this.$set(this, 'headerConfig', headerConfig)
  },
  mounted() {
    this.startTimer()
    if (this.userInfo.account) {
      this.$nextTick(() => {
        this.isSetShare();
        this.newUserInfo = JSON.parse(JSON.stringify(this.userInfo))
        if (this.activeInfo.is_bind) {
          delete this.newUserInfo.role_name
        }
      })
    } else {
      this.getLoginContainer()
    }
    this.logger.sum('拳新版本_角色页');

  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  computed: {
    ...mapState(['userInfo', 'activeInfo', 'isShowLogin', 'isShowOs']),
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (oldValue.account) {
          if (newValue.account !== oldValue.account) {
            if (!newValue.account) {
              // TAG: 注销的时候
              this.reInit();
            } else {
              // console.log('登录成功');
              this.getLoginContainer()
            }
          }
        }
      }
    },
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        // 找到当前为 2 的索引
        let currentIndex = this.skill_intro_items.findIndex(i => i.status === 2)
        // 计算下一个索引（循环）
        let nextIndex = (currentIndex + 1) % this.skill_intro_items.length

        // 重置所有 status = 1
        this.skill_intro_items.forEach(item => { item.status = 1 })
        // 更新下一个为选中
        this.skill_intro_items[nextIndex].status = 2

        // 更新 skillClass 和 skillGif
        this.skillClass = this.skill_intro_items[nextIndex].class
        this.skillGif = this.skill_intro_items[nextIndex].gif
      }, 5000)
    },
    showSkillIntro(index) {
      this.skill_intro_items.forEach(element => {
        element.status = 1
      });
      this.skill_intro_items[index].status = 2
      this.skillClass = this.skill_intro_items[index].class
      this.skillGif = this.skill_intro_items[index].gif
    },
    // 初始化
    getLoginContainer() {
      onGetInitDataAPI()
        .then((response) => {
          if (Number(response.code) == 200) {
            this.activity = response.data.activity;
            this.user_info = response.data.user_info;

            this.isBook = response.data.activity.is_book; // 是否预约

            this.onInitDataCallback(response);

            this.newUserInfo = JSON.parse(JSON.stringify(response.data.user_info))
            if (response.data.activity.is_bind) {
              delete this.newUserInfo.role_name
            } else {
              this.changeOsPopup(true)
            }
            this.setUserInfo(response.data.user_info);
            this.setActiveInfo(response.data.activity);

            setTimeout(() => { this.showTopBox = true; }, 10);
            setTimeout(() => { this.showTitleBox = true; }, 200);
            return;
          } else {
            setTimeout(() => { this.showTopBox = true; }, 10);
          }
        })
    },
    getSelectInfo(selectInfo) {
      this.selectInfo = selectInfo;
      selectInfo.account = this.userInfo.account;
      this.setUserInfo(selectInfo);
    },
    // 区组弹窗注销-相关参数复位
    osCancell() {
      this.changeOsPopup(false);
    },
    handleSlideChange(index) {
      const trackMap = [
        '版本-新主角',
        '版本-新地区',
        '版本-新载具'
      ];

      const eventName = trackMap[index];
      if (eventName) {
        this.logger.sum(`五周年庆_${eventName}`);
      }

      this.goToSlide(index);
    },
    goToSlide(targetIndex) {
      const swiper = this.mySwiper;
      const currentIndex = swiper.activeIndex;
      const slides = Array.from(swiper.slides);

      const matchingIndexes = slides
        .map((slide, i) => ({
          index: i,
          realIndex: +slide.getAttribute('data-swiper-slide-index')
        }))
        .filter(slide => slide.realIndex === targetIndex)

      const nearest = matchingIndexes.reduce((prev, curr) => {
        return Math.abs(curr.index - currentIndex) < Math.abs(prev.index - currentIndex)
          ? curr
          : prev;
      });

      if (nearest) {
        swiper.slideTo(nearest.index, 200);
        this.activeIndex = targetIndex;
      }
    },
    // 预约
    appoint() {
      this.logger.sum('五周年庆_立即预约');

      // 有无登录
      if (this.userInfo.account === undefined || this.userInfo.account === '') {
        // this.autoOpenOS = true;
        this.changeLoginPopup(true);
        return
      }

      appointAPI().then((response) => {
        if (response.code == 200) {
          this.appointSuccessShow = true;
          this.logger.sum('五周年庆_预约成功');
          this.isBook = true;
          this.getLoginContainer();
        } else {
          this.onToast(response.message);
        }
      });
    },
    sign() {
      this.logger.sum('五周年庆_day' + (this.signCount + 1) + '签到-立即领取');
      signAPI().then((response) => {
        if (response.code == 200) {
          this.signSuccessShow = true;
          this.getLoginContainer()
        } else {
          this.onToast(response.message);
        }
      });
    },
    download() {
      this.logger.sum('五周年庆_day3签到-下载游戏');
    },
    // 预约后转为签到
    changeToSign() {
      this.appointSuccessShow = false;
    },
    loginSuccess() {
      this.getLoginContainer();
    },
    reInit() {
      this.changeOsPopup(false);
      this.clearActiveInfo();
    },
    clearActiveInfo() {
      this.isBook = false;
      this.isCanSign = false;
      this.isDaySign = false;
      this.signCount = 0;

      this.setInitUserInfo();
      this.setInitActiveInfo();
    },
    onToast(config, duration) {
      const curConfig = {
        duration: duration || 1000,
        className: 'toasts'
      }
      if (!config) {
        console.error('缺少config参数')
        return false
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig)
    },
    showPopup(name) {
      switch (name) {
        case 'welfareDetailShow':
          this.welfareDetailShow = true;
          this.logger.sum('五周年庆_打开福利详情弹窗');
          break
      }
    },
    goLink(url, loggerName) {
      if (url === '') return
      Indicator.open();
      this.logger.sum(loggerName)
      setTimeout(() => { window.location.href = url; Indicator.close(); }, 200)
    },
    closePopup(name) {
      this[name] = false;
    },
    // 微信分享
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/tideng/recall/anniversary${getRandomString()}`,
        title: '《提灯与地下城》新版本火热上线',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/9VHWniV91Q3sfOtCISCEmR9aWVEaAj7jLqrT2VKZ.png',
        desc: '参与组队积分活动，可获得史诗级头衔、10星装备升星券等丰厚奖励，集结归来的灯友，就差你了！'
      })
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
      "setActiveInfo"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/tideng/recall/anniversary/index.vue